import aimmaChroniclePreview from "../../../image/health/aimma-doctor/aimma-chronicle-preview.png";
import aimmaDiagnosisPreview from "../../../image/health/aimma-doctor/aimma-diagnosis-preview.png";
import aimmaReminderPreview from "../../../image/health/aimma-doctor/aimma-reminder-preview.png";
import aimmaReportingPreview from "../../../image/health/aimma-doctor/aimma-reporting-preview.png";
import aimmaStage03 from "../../../image/health/Aimma_stage03.png";
import aimmaStage04 from "../../../image/health/Aimma_stage04.png";
import aimmaTriagePreview from "../../../image/health/aimma-doctor/aimma-triage-preview.png";
import physicianDashboardHero from "../../../image/health/aimma-doctor/physician-dashboard-hero.png";
import { isAimmaProductId } from "../healthTypes";

/** Per-agent interface preview — swap src when dedicated assets are added. */
export const healthAimmaDoctorAgentPreviewAssets: Record<string, string> = {
    "aimma-chronicle": aimmaChroniclePreview,
    "aimma-listening": aimmaStage03,
    "aimma-triage": aimmaTriagePreview,
    "aimma-diagnosis": aimmaDiagnosisPreview,
    "aimma-treatment": aimmaStage04,
    "aimma-reminder": aimmaReminderPreview,
    "aimma-reporting": aimmaReportingPreview,
};

export function getAimmaDoctorAgentPreviewSrc(productId: string | undefined): string {
    if (productId && healthAimmaDoctorAgentPreviewAssets[productId]) {
        return healthAimmaDoctorAgentPreviewAssets[productId];
    }
    if (productId && isAimmaProductId(productId)) {
        return physicianDashboardHero;
    }
    return physicianDashboardHero;
}
